define([], function () {

	function getUsers() {
		return typeof window !== "undefined" ? window.__userModule : null;
	}

	var key = "--:app:theme";
	var current_theme = webix.storage.local.get(key) || "siberia:webix";

	function _get_theme() {
		var users = getUsers();
		if (users && users.getCurrentUser())
			return users.getCurrentUser().settings.theme;

		return current_theme;
	}

	function _set_theme(theme) {
		if (theme === current_theme) {
			return;
		}
		webix.storage.local.put(key, theme);
		var users = getUsers();
		if (users && users.getCurrentUser())
			users.saveSetting("theme", theme, theme != current_theme);
		else
			document.location.reload();

		current_theme = theme;
	}

	var api = {
		setTheme: _set_theme,
		getTheme: _get_theme,
		isNow: function (val) { return val == current_theme; }
	};

	if (typeof window !== "undefined")
		window.__themeModule = api;

	return api;
});